import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Errors } from '../enums/errors.enum';
import {freshCompilationTicket} from "@angular/compiler-cli/src/ngtsc/core";

export class FormUtility {

  constructor(public translate: TranslateService) {

  }

  static showFormErrors(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      this.getControl(key, form)?.markAsTouched();
      const control = this.getControl(key, form);
      if (control && control.invalid) {
        if (control.errors && control.errors['custom']) {
          this.markAsError(control, undefined, control.errors['custom']);
        } else {
          this.markAsError(control);
        }
      }
    });
  }

  static deepSearchErrors(form: FormGroup, pathPrefix?: string): { path: string, msg: string }[] {
    let errors: any[] = [];

    Object.keys(form.controls).forEach(key => {
      this.getControl(key, form)?.markAsTouched();
      const control = this.getControl(key, form);

      if (control && (control as any).controls) {
        errors = errors.concat(this.deepSearchErrors(control as FormGroup, pathPrefix ? (pathPrefix+'.'+key) : key));
      } else {
        if (control?.invalid) {
          let msg = '';

          if (control.errors) {
            let _errors = Object.keys(control.errors).filter(
              (key) => control.errors && control.errors[key]
            );
            _errors = _errors.map((key) => {
              if (control.errors) {
                if (key === 'custom') {
                  return control.errors[key];
                } else {
                  const keyIndex = Object.keys(Errors).indexOf(key);
                  return Object.values(Errors)[keyIndex];
                }
              } else {
                return '';
              }
            })
            msg = _errors[0];
          }

          if (msg) {
            errors.push({
              path: pathPrefix ? (pathPrefix+'.'+key) : key,
              msg
            });
          }
        }
      }

    });
    return errors;
  }

  static getControl(path: AbstractControl | (string | number)[] | string | null, form?: FormGroup): AbstractControl | null | undefined {

    if (Array.isArray(path) || typeof path === 'string') { // (string | number)[] | string
      return form?.get(path);
    } else { // AbstractControl
      return path as AbstractControl;
    }

  }

  static markAsError(path: AbstractControl | (string | number)[] | string | null, form?: FormGroup, error = ''): void {

    const control = this.getControl(path, form);
    this.pushError(control, 'custom', error);
    control?.markAsTouched();

  }

  static pushError(ac: AbstractControl | null | undefined, errorKey: string, error: string | boolean): void {

    let fcErrors = ac?.errors as any;
    if (!fcErrors) {
      fcErrors = {};
    }
    fcErrors[errorKey] = error;
    ac?.setErrors(fcErrors);

  }

  static removeError(ac: AbstractControl | null | undefined, errorKey: string): void {

    if (ac?.errors) {
      ac.errors[errorKey] = false;
      ac.updateValueAndValidity();
    }

  }

  static isEmptyField(path: AbstractControl | (string | number)[] | string | null, form?: FormGroup): boolean {

    const control = this.getControl(path, form);
    return !control?.value;

  }

  static toFormData(data: any) {
    const formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  }

  static buildFormData(formData: any, data: any, parentKey?: any) {
    if (data && Array.isArray(data) && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key as any], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
      });
    } else {
      const value = data;

      if (value !== null) formData.append(parentKey, value);
    }
  }

}
